import Loading from './Loading';
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserInfoQuery } from '../lib/Queries';
import { getEmailDomain } from '~/lib/StringUtils';

const RequiresAuth = ({ children }) => {
    const {
        loginWithRedirect,
        isAuthenticated,
        isLoading,
        user: oAuthUser,
    } = useAuth0();
    const { data: userInfo } = useUserInfoQuery();
    useEffect(() => {
        if (userInfo) {
            const emailDomain = getEmailDomain(userInfo?.email);
            // setFeatureFlagAttributes({
            //     id: userInfo.id,
            //     emailDomain,
            //     email_verified: oAuthUser?.email_verified,
            // });
        }
    }, [oAuthUser, userInfo]);

    if (isLoading) {
        return (
            <div className="h-screen w-screen bg-gray-100 flex items-center justify-center">
                <div className="text-2xl font-bold">
                    <Loading />
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log('setting redirect to', window.location.pathname);
        localStorage.setItem('redirect-after-login', window.location.pathname);
        setTimeout(() => {
            loginWithRedirect();
        }, 250);

        return (
            <div className="h-screen w-screen bg-gray-100 flex items-center justify-center">
                <div className="text-2xl font-bold text-gray-500">
                    Logging in...
                </div>
            </div>
        );
    }

    return children;
};

export default RequiresAuth;
